export default __webpack_public_path__ + "static/media/kidney-yellow.7760a419.svg";